export const PAYMENT_FREQUENCY_ITEMS = [
  {
    text: "Annual",
    value: "Annual",
  },
  {
    text: "Monthly",
    value: "Monthly",
  },
  {
    text: "Monthly - 10 Monthly Payment Option",
    value: "Monthly2MonthsFree",
  },
];

export const PAYMENT_FREQUENCY_ITEMS_TLI = [
  {
    text: "One off payment",
    value: "Annual",
  },
  {
    text: "Monthly",
    value: "Monthly",
  },
];

export const B2B_HJO_PAYMENT_FREQUENCY_ITEMS_ADVISED = [
  {
    text: "Annual",
    value: "Annual",
  },
  {
    text: "Monthly",
    value: "Monthly",
  },
];

export const PAYMENT_FREQUENCY_ITEMS_PSDEFERRED = [
  {
    text: "Annual",
    value: "Annual",
  },
  {
    text: "Monthly",
    value: "Monthly",
  },
  {
    text: "Monthly – 9 Monthly Payment Option",
    value: "Monthly3MonthsDeferred",
  },
];

export const PAYMENT_METHOD_ITEMS = [
  {
    text: "Direct Debit",
    value: "DirectDebit",
  },
  {
    text: "Credit / Debit Card",
    mobileText: "Credit Card",
    value: "CreditCard",
  },
];

export const DIRECT_DEBIT_DATE_ITEMS = [
  {
    text: "1st",
    value: "First",
  },
  {
    text: "7th",
    value: "Seventh",
  },
  {
    text: "14th",
    value: "Fourteenth",
  },
  {
    text: "21st",
    value: "TwentyFirst",
  },
  {
    text: "24th",
    value: "TwentyFourth",
  },
];

export const DIRECT_DEBIT_DATE_ITEMS_TEXT_FULL = [
  {
    text: "1st of the month",
    value: "First",
  },
  {
    text: "7th of the month",
    value: "Seventh",
  },
  {
    text: "14th of the month",
    value: "Fourteenth",
  },
  {
    text: "21st of the month",
    value: "TwentyFirst",
  },
  {
    text: "24th of the month",
    value: "TwentyFourth",
  },
];

export const FREQUENTLY_PAYMENT_ITEMS = [
  {
    text: "Annual",
    value: "Annual",
  },
  {
    text: "Monthly (12 months)",
    value: "Monthly",
  },
];

export const ARRANGE_COVER_DESCRIPTION =
  "When choosing to opt out of our automatic renewal service, please make sure you have adequate insurance cover in place once your policy comes to an end as you will no longer have insurance with Paymentshield.";

export const ARRANGE_COVER_DESCRIPTION_TLI =
  "Make sure you have adequate insurance cover in place for your belongings and liabilities as a tenant once your policy ends.";

export const AUTO_RENEW = [
  {
    title: "Continuous cover for peace of mind",
    description:
      "Paymentshield will renew your policy each year so that you are not left without insurance.",
  },
  {
    title: "Our cheapest price available",
    description:
      "By searching their panel of insurers Paymentshield will always look to provide the cheapest price they can offer you each year.",
  },
  {
    title: "You’re still in control",
    description:
      "You can cancel your policy or opt out of auto renewal free of charge at any time by calling or using the chat service.",
  },
  {
    title: "Stay informed",
    description:
      "Paymentshield will contact you up to 30 days before your policy renews to confirm the cover, price & insurer for your next insurance term.",
  },
];
export const AUTO_RENEW_TLI = [
  {
    title: "Continuous cover for peace of mind",
    description:
      "Paymentshield will renew your policy each year so that you are not left without insurance.",
  },
  {
    title: "You’re still in control",
    description:
      "You can cancel your policy or opt out of auto renewal free of charge at any time by calling or using the chat service.",
  },
  {
    title: "Stay informed",
    description:
      "Paymentshield will contact you up to 30 days before your policy renews to confirm the cover, price & insurer for your next insurance term.",
  },
];
export const DO_NOT_AUTO_RENEW = [
  {
    title: "Not automatically insured",
    description:
      "By searching their panel of insurers, Paymentshield will still offer you their most competitive price at the end of the policy.",
  },
  {
    title: "You'll need to arrange cover",
    description:
      "When choosing to opt out of our automatic renewal service, please make sure you have adequate insurance cover in place once your policy comes to an end as you will no longer have insurance with Paymentshield.",
  },
  {
    title: "Stay informed",
    description:
      "Paymentshield will contact you up to 30 days before your policy renews to confirm the cover, price &  insurer for your next insurance term.",
  },
];
export const DO_NOT_AUTO_RENEW_TLI = [
  {
    title: "You'll need to arrange cover",
    description:
      "Make sure you have adequate insurance cover in place for your liabilities as a tenant once your policy ends.",
  },
  {
    title: "Stay informed",
    description:
      "Paymentshield will contact you with a renewal quote, which includes the price and cover, 30 days before your renewal is due.  You will need to contact Paymentshield to renew the policy or you will need to arrange cover elsewhere.",
  },
];
